define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 背景模式。
     *
     * @exports EnumBackdropMode
     * 
     * @see TextSymbol#backdropMode
     */
    var EnumBackdropMode = {
        /**
         * 无背景。
         * @type {Number}
         * @constant
         */
        NONE: 0,

        /**
         * 纹理背景。
         * @type {Number}
         * @constant
         */
        TEXTURE: 1,

        /**
         * 颜色背景。
         * @type {Number}
         * @constant
         */
        COLOR: 2
    }
    
    freezeObject(EnumBackdropMode)

    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {Number} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumBackdropMode) {
            if (EnumBackdropMode.hasOwnProperty(key) && EnumBackdropMode[key] === value) {
                return key
            }
        }
        return undefined
    }

    return {
        NONE: 0,
        TEXTURE: 1,
        COLOR: 2,
        getName: getName
    }
})